import React from "react";

import {ForYouConsultantSection} from "../components/ForYouConsultantSection";
import {ForYouFaq} from "../components/ForYouFaq";
import {ForYouHeader} from "../components/ForYouHeader";
import {ForYouHowItWorks} from "../components/ForYouHowItWorks";
import {ForYouModal} from "../components/ForYouModal";
import {ForYouWhyUs} from "../components/ForYouWhyUs";

export const ForYouLanding = () => {
    return (
        <>
            <ForYouHeader />
            <ForYouWhyUs />
            <ForYouConsultantSection />
            <ForYouHowItWorks />
            <ForYouFaq />
            <ForYouModal />
        </>
    );
};
import React from "react";

import {ForYouConsultantSection} from "../components/ForYouConsultantSection";
import {ForYouFaq} from "../components/ForYouFaq";
import {ForYouHeader} from "../components/ForYouHeader";
import {ForYouHowItWorks} from "../components/ForYouHowItWorks";
import {ForYouModal} from "../components/ForYouModal";
import {ForYouWhyUs} from "../components/ForYouWhyUs";

export const ForYouLanding = () => {
    return (
        <>
            <ForYouHeader />
            <ForYouWhyUs />
            <ForYouConsultantSection />
            <ForYouHowItWorks />
            <ForYouFaq />
            <ForYouModal />
        </>
    );
};
